<template>
  <v-container class="event-detail" v-if="enrollment" fluid>
    <HkiaraceBannerFrame :src="require('../../../assets/acc.jpg')"
                         :label="$t('my_event_list.detail_title')">
      <v-container class="event-detail-content">
        <v-row>
          <v-col>

            <v-row>
              <v-col>
                <v-text-field :label="$t('admin_hkiarace.event')"
                              readonly
                              hide-details
                              :value="$sanitizeHtml(enrollment.event.name)"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="enrollment.event.signup_mode === 2">
              <v-col>
                <v-text-field :label="$t('event.session')"
                              readonly
                              hide-details
                              :value="enrollment.session.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="enrollment.event.signup_mode === 3">
              <v-col>
                <v-text-field :label="$t('event.series')"
                              readonly
                              hide-details
                              :value="enrollment.series.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field :label="$t('admin_enrollment.enrolled_at')"
                              readonly
                              hide-details
                              :value="$parseDate(enrollment.create_at, 'yyyy-MM-dd HH:mm')"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="enrollment.series">
              <v-col>
                <v-text-field :label="$t('admin_enrollment.series')"
                              readonly
                              hide-details
                              :value="enrollment.series.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="enrollment.session">
              <v-col>
                <v-text-field :label="$t('admin_enrollment.session')"
                              readonly
                              hide-details
                              :value="enrollment.session.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="eventNeedPayment">
              <v-col>
                <v-textarea :label="$t('admin_enrollment.meta')"
                            readonly
                            hide-details
                            auto-grow
                            no-resize
                            :rows="1"
                            :value="enrollmentDetails"></v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="eventNeedPayment">
              <v-col>
                <v-text-field :label="$t('my_event_list.pay_amount')"
                              readonly
                              hide-details
                              :value="payingEventPayingAmount"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('admin_enrollment.status')"
                              readonly
                              hide-details
                              :value="enrollmentStatusLabel"></v-text-field>
              </v-col>
              <v-col cols="12" md="6"
                     v-if="eventNeedPayment && !eventPaid"
                     class="text-right">
                <v-btn color="primary"
                       :block="$vuetify.breakpoint.width < 960"
                       @click="payEventDialogShown = true">
                  {{ $t('my_event_list.pay') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-left">
                <v-btn color="primary"
                       :block="$vuetify.breakpoint.width < 960"
                       @click="$router.back()">
                  {{ $t('back') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

    </HkiaraceBannerFrame>

    <v-dialog v-model="payEventDialogShown"
              width="80vw"
              max-width="400px">
      <v-card light
              class="event-pay-dialog"
              v-if="eventNeedPayment && !eventPaid"
              width="80vw"
              max-width="400px">
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col>
                <v-text-field readonly
                              hide-details
                              :label="$t('my_event_list.pay_amount')"
                              :value="payingEventPayingAmount"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12"
                     :class="['event-pay-dialog-payment-method', {'active': paymentMethod === 'cyber_source'}]"
                     @click="paymentMethod = 'cyber_source'">
                <v-img class="event-pay-dialog-payment-method-logo"
                       :src="require('../../../assets/logo-credit-cards.png')"
                       height="64px"></v-img>
              </v-col>
<!--              <v-col cols="1" v-if="$vuetify.breakpoint.mdAndUp"></v-col>-->
<!--              <v-col cols="12" md="4"-->
<!--                     :class="['event-pay-dialog-payment-method', {'active': paymentMethod === 'union_pay'}]"-->
<!--                     @click="paymentMethod = 'union_pay'">-->
<!--                <v-img class="event-pay-dialog-payment-method-logo"-->
<!--                       :src="require('../../../assets/logo-union-pay.png')"-->
<!--                       height="64px"></v-img>-->
<!--              </v-col>-->
            </v-row>
            <v-row v-if="paymentMethod === 'cyber_source'">
              <v-col>
                <v-radio-group v-model="selectedPaymentToken">
                  <v-radio v-for="paymentToken in paymentTokens"
                           :key="paymentToken.id"
                           :value="paymentToken.id">
                    <template #label>
                      <v-img :src="cardTypeLogo[paymentToken.card_type]"
                             :max-width="40"
                             :max-height="30"
                             class="mr-4"></v-img>
                      {{ `${paymentToken.card_number} (${paymentToken.card_expiry_date})` }}
                    </template>
                  </v-radio>
                  <v-radio :value="false">
                    <template #label>
                      <v-icon class="mr-4">fas fa-plus-square</v-icon>
                      {{ $t('booking_preview.add_payment_token') }}
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text
                 @click="payEventDialogShown = false">
            {{ $t('cancel') }}
          </v-btn>

          <v-btn text color="primary"
                 :disabled="!paymentMethod"
                 @click="initEventPayment">
            {{ $t('my_event_list.pay') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import {ref, computed, onMounted, watch} from '@vue/composition-api';

export default {
  name: 'EventDetail',
  components: {HkiaraceBannerFrame},
  setup(props, {root}) {
    const enrollmentId = ref(root.$route.params.enrollmentId);
    const enrollment = ref(null);
    const getEnrollment = function () {
      root.$callAPI('hkiarace/event/my_enrollment/', {
        enrollment_id: enrollmentId.value,
      }, function (response) {
        enrollment.value = response.body.enrollment;
      }, function (response) {
        if (response.status === 401) {
          root.$router.push({name: 'login', query: {after: root.$route.path}});
        } else {
          root.$showAlertMessage();
        }
      })
    }

    // Payment Status
    const paymentSuccess = function (paymentRecord) {
      let paymentSuccess = false;
      if (paymentRecord.payment_record.payment_method === 'cyber_source') {
        paymentRecord.payment_record.cyber_source_payment_records.forEach((r) => {
          if (r.decision === 'ACCEPT') {
            paymentSuccess = true;
          }
        })
      } else if (paymentRecord.payment_record.payment_method === 'union_pay') {
        paymentRecord.payment_record.union_pay_payment_records.forEach((r) => {
          if (r.response_code === '00') {
            paymentSuccess = true;
          }
        })
      }

      return paymentSuccess;
    }
    const eventNeedPayment = computed(()=> {
      if (JSON.parse(enrollment.value.event.fee_tiers || '[]').length === 0) {
        return false;
      }

      return enrollment.value.status === 1;
    });
    const eventPaid = computed(()=> {
      let paid = false;
      enrollment.value.hkiarace_event_payment_records.forEach((r) => {
        if (paymentSuccess(r)) {
          paid = true;
        }
      });
      return paid;
    })
    const enrollmentDetails = computed(()=> {
      if (!eventNeedPayment.value) {
        return '';
      }

      let fee_tiers = JSON.parse(enrollment.value.event.fee_tiers);
      let meta = JSON.parse(enrollment.value.meta);

      let results = [];

      fee_tiers.forEach((t) => {
        if (meta[t['id']]) {
          results.push(root.$localeGet(t, 'name') + ': ' + meta[t['id']]);
        }
      });

      return results.join('\r');
    })
    const enrollmentStatusLabel = computed(()=> {
      if (eventNeedPayment.value && !eventPaid.value) {
        return root.$t('enrollment_status.pending_payment');
      }

      return {
        '0': root.$t('enrollment_status.pending'),
        '1': root.$t('enrollment_status.accepted'),
        '-1': root.$t('enrollment_status.rejected'),
      }[enrollment.value.status];
    })
    const payingEventPayingAmount = computed(()=> {
      if (!enrollment.value) {
        return 0;
      }

      let feeTiers = JSON.parse(enrollment.value.event.fee_tiers || '[]');

      if (feeTiers.length === 0) {
        return 0;
      } else if (!feeTiers[0].name_en) {
        return feeTiers[0].fee;
      } else {
        let total = 0;
        let meta = JSON.parse(enrollment.value.meta);

        feeTiers.forEach((f) => {
          if (meta[f.id]) {
            total += meta[f.id] * f.fee;
          }
        });

        return total;
      }
    })

    const payEventDialogShown = ref(false);

    const paymentMethod = ref(null);

    // Payment Token
    const selectedPaymentToken = ref(false);
    const paymentTokens = ref([]);
    const cardTypeLogo = ref({
      '001': require('@/assets/visa.jpg'),
      '002': require('@/assets/mastercard.png'),
      '007': require('@/assets/jcb.gif'),
    });
    const getPaymentTokens = function () {
      root.$callAPI('payment/cyber_source/payment_tokens/', {}, (response) => {
        paymentTokens.value = response.body.payment_tokens;

        if (paymentTokens.value.length > 0) {
          selectedPaymentToken.value = paymentTokens.value[0].id;
        }
      })
    }
    watch(() => paymentMethod.value, (newValue) => {
      if (newValue === 'cyber_source') {
        getPaymentTokens();
      }
    });

    const initEventPayment = function () {
      if (confirm(root.$t('booking_preview.redirect_warning'))) {
        root.$callAPI('hkiarace/event/init_payment/', {
          enrollment_id: enrollment.value.id,
          payment_method: paymentMethod.value,
          payment_token_id: selectedPaymentToken.value,
        }, function (response) {
          postForm(response.body.url, response.body.params)
        });
      }
    }
    const postForm = function (path, params, method = 'post') {
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
      root.$startLoading();
    }

    onMounted(()=> {
      getEnrollment();
    })

    return {
      enrollmentId,
      enrollment,

      eventNeedPayment,
      eventPaid,
      enrollmentDetails,
      enrollmentStatusLabel,
      payingEventPayingAmount,

      payEventDialogShown,

      paymentMethod,

      selectedPaymentToken,
      paymentTokens,
      cardTypeLogo,

      initEventPayment,
    }
  },
}
</script>

<style lang="less">
.event-detail {
  .event-detail-content {
    padding: 2rem;
    background-color: white;

    .event-detail-title {
      color: #8E765B;
      font-size: 1.2rem;
      font-weight: bold;
    }

    .v-label {
      color: #8E765B;
    }

    .v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }

    .v-text-field > .v-input__control > .v-input__slot:after {
      display: none;
    }
  }
}

.event-pay-dialog {
  .v-label {
    color: #8E765B;
  }

  .v-input--is-readonly > .v-input__control > .v-input__slot:before {
    display: none;
  }

  .v-input--is-readonly > .v-input__control > .v-input__slot:after {
    display: none;
  }

  .event-pay-dialog-payment-method {
    border: 2px solid rgba(0, 0, 0, 0.2);
    cursor: pointer;

    &:hover, &.active {
      border-color: #8E765B;
    }

    .event-pay-dialog-payment-method-logo {

    }
  }
}
</style>
